(function initApollo() {
  const randomString = Math.random().toString(36).substring(7);
  const script = document.createElement("script");

  script.src = `https://assets.apollo.io/micro/website-tracker/tracker.iife.js?nocache=${randomString}`;
  script.async = true;
  script.defer = true;

  script.onload = function () {
    if (window.trackingFunctions && window.trackingFunctions.onLoad) {
      window.trackingFunctions.onLoad({ appId: "663316c662f42b043aaac4b2" });
    } else {
      console.error("Apollo trackingFunctions not available.");
    }
  };

  document.head.appendChild(script);
})();
